import React from 'react';
import { withStyles } from '@mui/styles';
import Switch from '@mui/material/Switch';

const IOSSwitch = withStyles((theme) => {
  const spacing = typeof theme.spacing === 'function' ? theme.spacing(1) : '8px';
  const white = theme?.palette?.common?.white || '#fff';
  const grey400 = theme?.palette?.grey?.[400] || '#bdbdbd';
  const createTransition = theme?.transitions?.create || (() => 'all 0.3s ease');

  return {
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: spacing,
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        color: white,
        '& + $track': {
          backgroundColor: '#00BC97',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        border: `6px solid ${white}`,
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${grey400}`,
      backgroundColor: '#CCCCCC',
      opacity: 1,
      transition: createTransition(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  };
})(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));

export default IOSSwitch;